export default "__VITE_ASSET__DM9z3ho2__"